import { h, render, Component } from 'preact';
import moment from 'moment';

import SelectBox from './SelectBox';

class Form extends Component {

	render() {

		const now = Date.now();
		const idDay = 'day-' + this.props.calculatorTypeUid + '-' + now;
		const idMonth = 'month-' + this.props.calculatorTypeUid + '-' + now;
		const idYear = 'year-' + this.props.calculatorTypeUid + '-' + now;
		const idStart = 'start-' + this.props.calculatorTypeUid + '-' + now;

		return (

		<div className="premium-calc__box  premium-calc__box--inputs">

			<h3 className="copy-h3 premium-calc__header">Ihre Angaben</h3>

			<div className="form-row">
				<div className="form-group">
					<label
						className="control-label premium-calc__label"
						htmlFor={idDay}>
						<span>Geburtstag</span>
					</label>
					<div className="input premium-calc__birthday">
						<SelectBox
							className="form-control premium-calc__birthday-day"
							id={idDay}
							ariaLabel="Geburtstag"
							options={this.calendarDays}
							onChange={this.props.handleBirthDayChange}
							defaultValue={this.props.birthDay}
						/>
						<SelectBox
							id={idMonth}
							className="form-control premium-calc__birthday-month"
							ariaLabel="Geburtsmonat"
							options={this.calendarMonths}
							onChange={this.props.handleBirthMonthChange}
							defaultValue={this.props.birthMonth}
						/>
						<SelectBox
							id={idYear}
							className="form-control premium-calc__birthday-year"
							ariaLabel="Geburtsjahr"
							options={this.calendarYears}
							onChange={this.props.handleBirthYearChange}
							defaultValue={this.props.birthYear}
						/>
					</div>
				</div>
			</div>

			<div className="form-row">
				<div className="form-group premium-calc__insurance-start-group">
					<label
						className="control-label premium-calc__label"
						htmlFor={idStart}>
						<span>Versicherungsbeginn</span>
					</label>
					<div className="input">
						<SelectBox
							id={idStart}
							className="premium-calc__insurance-start form-control"
							ariaLabel="Versicherungsbeginn"
							options={this.props.insuranceEntryDates}
							onChange={this.props.handleInsuranceEntryChange}
							defaultValue={this.props.insuranceEntryDate}
						/>
					</div>
				</div>
			</div>
			<div className="form-row">
				<div className="form-group">
					<button
						className="btn btn--primary premium-calc__form-btn"
						onClick={this.props.handleCalculate}
						aria-label="Beitrag berechnen"
					>Berechnen</button>
				</div>
			</div>
		</div>
		);
	}

	get calendarDays() {
		const days = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'];
		return days;
	}

	get calendarMonths() {
		const months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
		return months;
	}

	get calendarYears() {
		const minAge = this.minAge;
		const maxAge = this.maxAge;

		let calenderYears = [];
		let years = null;
		for (var i = minAge; i <= maxAge; i++) {
            years = moment().subtract(i,'years').add(1, 'month').format('YYYY');
			calenderYears.push(years);
		}

		return calenderYears;
	}

	get minAge() {
		return this.props.minAge || 15;
	}

	get maxAge() {
		return this.props.maxAge || 95;
	}
}

export default Form;
